import { render, staticRenderFns } from "./chaptersDetails.vue?vue&type=template&id=69232a4d"
import script from "./chaptersDetails.vue?vue&type=script&lang=js"
export * from "./chaptersDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports